import(/* webpackMode: "eager" */ "/app/src/app/(landing)/page.js");
